export default "__VITE_ASSET__B0SyAu5a__"